/** Caminho base da aplicação (`/conexao-varga`), sem a barra final. */
export const BASE_PATH: string = (import.meta.env.VITE_BASE_PATH ?? '/conexao-varga/').replace(
  /\/$/,
  '',
);

/** Link absoluto da landing do convite, para a mensagem de compartilhamento (UX §5.3). */
export function linkConvite(codigo: string): string {
  return `${window.location.origin}${BASE_PATH}/convite?codigo=${encodeURIComponent(codigo)}`;
}

/** `wa.me` de número em E.164 (só dígitos). Vazio → `null` (sem placeholder D2). */
export function linkWhatsApp(numero: string | null | undefined, texto?: string): string | null {
  if (!numero) return null;
  const digitos = numero.replace(/\D/g, '');
  if (digitos.length < 10) return null;
  const base = `https://wa.me/${digitos}`;
  return texto ? `${base}?text=${encodeURIComponent(texto)}` : base;
}
